import PosActions from '../../actions/PosActions';
import PosCartActions from '../../actions/PosCartActions';
import GuestStore from '../../stores/GuestStore';

import UserStore from '../../stores/UserStore';
import PosStore from '../../stores/PosStore';
import PosCartStore from '../../stores/PosCartStore';

import NetaAutoPrice from './neta/NetaAutoPrice.react';
import PosHeaderSearch from './header/PosHeaderSearch.react';
import { Fragment } from 'react';

class PosHeader extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading     : false,
            query       : '',
            sidebarPage : PosStore.getState().sidebarPage,
            showSidebar : PosStore.getState().showSidebar,
            confirmLastFour : false,
            lastFour        : '',
            addByTabMessage : [],
            disableSearch   : UserStore.getState().selectedLocation.ManagerSearchFlag,
        };

        this.onPosStoreChange = this.onPosStoreChange.bind(this);
        this.drawSearchBar = this.drawSearchBar.bind(this);
    }

    componentDidMount() {
        PosStore.addChangeListener(this.onPosStoreChange);
        GuestStore.addChangeListener(this.drawSearchBar);
        PosCartStore.addChangeListener(this.drawSearchBar);

        var self = this;

        $(window).on('resize', this.drawSearchBar);

        this.drawSearchBar();
    }

    componentWillUnmount() {
        PosStore.removeChangeListener(this.onPosStoreChange);
        GuestStore.removeChangeListener(this.drawSearchBar);
        PosCartStore.removeChangeListener(this.drawSearchBar);

        $(window).off('resize', this.drawSearchBar);
    }

    onPosStoreChange() {
        var self = this;

        this.drawSearchBar();

        var pos = PosStore.getState();

        this.setState({
            sidebarPage : pos.sidebarPage,
            showSidebar : pos.showSidebar,
        }, () => {
            self.drawSearchBar();
        });
    }

    drawSearchBar() {
        setTimeout(() => {
            var $headerSearch = $('.pos-header__search');
            var $headerNav = $('#pos-header-nav');

            if ($headerSearch.length && $headerNav.length) {
                var offset = $headerSearch.offset();
                var navWidth = $headerNav.width();
                var left = offset.left ? offset.left : 0;
                var diff = navWidth - left;

                if (diff > 0) {
                    $('#product-search').css({
                        'width' : $('.pos-header__search').width() - 91 - diff - 10,
                    });
                }
            }
        }, 100);
    }

    toggle(type) {
        var pos = PosStore.getState();

        if (pos.sidebarPage === type && pos.showSidebar)
            PosActions.toggleSidebar();
        else {
            PosActions.setSidebarPage(type);

            if (!pos.showSidebar)
                PosActions.toggleSidebar();
        }
    }

    render() {
        var self = this;
        var guest = this.props.guest;
        var page  = this.props.page;
        var cart  = this.props.cart;
        var sidebarPage = this.state.sidebarPage;
        var showSidebar = this.state.showSidebar;
        var preOrders  = this.props.preOrders;
        var appliedDiscounts = this.props.appliedDiscounts;
        var appliedFeesDonations = this.props.appliedFeesDonations;

        var itemsInCart = 0;
        for (var i=0; i<cart.length; i++)
            itemsInCart += cart[i].QtyAllocated;

        var preOrderQty = 0;
        for (var i=0; i<preOrders.length; i++)
            preOrderQty += preOrders[i].QtySelected;

        var discountsQty = appliedDiscounts.length;
        var appliedFeesDonationsQty = appliedFeesDonations.length;

        var loc   = UserStore.getApiData().LspId;

        return (
            <div
                className='pos-header'>

                <ul id='pos-header-nav'>
                    <li
                        className={(showSidebar && sidebarPage === 'menu' ? 'pos-header__active' : '')}
                        onClick={this.toggle.bind(this, 'menu')}
                        title='Main Menu'>

                        <i className='fa fa-bars' aria-hidden='true' />
                    </li>
                    <li className='pos-header__space' />
                    <li
                        className={(showSidebar && sidebarPage === 'profile' ? 'pos-header__active' : '')}
                        onClick={this.toggle.bind(this, 'profile')}
                        title='Guest Profile'>

                        <i className='fa fa-user' aria-hidden='true' />
                    </li>
                    <li className='pos-header__space' />
                    <li
                        className={(showSidebar && sidebarPage === 'notes' ? 'pos-header__active' : '')}
                        onClick={this.toggle.bind(this, 'notes')}
                        title='Guest Notes'>

                        <i className='far fa-edit' aria-hidden='true' />
                    </li>
                    <li className='pos-header__space' />
                    <li
                        className={(page === 'cart' ? 'pos-header__active' : '')}
                        onClick={() => { this.props.setPage('cart'); PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId); }}
                        title='Cart'>

                        <i className='fa fa-shopping-cart' aria-hidden='true' /> ({itemsInCart})
                    </li>
                    <li className='pos-header__space' />
                    { preOrders.length > 0 &&
                        <li
                            className={(showSidebar && sidebarPage === 'pre-order' ? 'pos-header__active' : '')}
                            onClick={this.toggle.bind(this, 'pre-order')}
                            title='Pre-Orders'>


                            <i className='fa fa-cart-plus' aria-hidden='true' /> ({preOrderQty})
                        </li>
                    }
                    { preOrders.length > 0 &&
                        <li className='pos-header__space' />
                    }
                    <li
                        className={(showSidebar && sidebarPage === 'discounts' ? 'pos-header__active' : '')}
                        onClick={this.toggle.bind(this, 'discounts')}
                        title='Discounts'>

                        <i className='fa fa-percent' aria-hidden='true' /> ({discountsQty})
                    </li>

                    { UserStore.getState().selectedLocation.UseFeesDonations &&
                        <Fragment>
                            <li className='pos-header__space' />
                            <li
                                className={(showSidebar && sidebarPage === 'fees-donations' ? 'pos-header__active' : '')}
                                onClick={this.toggle.bind(this, 'fees-donations')}
                                title='Fees-Donations'>

                                <i className='fa fa-donate' aria-hidden='true' /> ({appliedFeesDonationsQty})
                            </li>
                        </Fragment>
                    }

                    { (loc == '1067' || loc == '18') &&
                        <li className='pos-header__space' />
                    }

                    <NetaAutoPrice
                        guest={guest} />
                </ul>

                <PosHeaderSearch
                    guest={guest}
                    searchText={this.props.searchText}
                    updateSearchText={this.props.updateSearchText}
                    onSearch={(page, query) => { this.props.onSearch(page, query); }}
                    onSearchFocus={this.props.onSearchFocus}
                />

            </div>
        );
    }
}

export default PosHeader;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/PosHeader.react.jsx